<section class="table-page fise-form-modal">
  <header class="fise-form-modal__header">
    <div class="fise-form-modal__title-wrap">
      <div class="fise-form-modal__icon">
        <mat-icon>apps</mat-icon>
      </div>
      <div>
        <h2>{{ tituloOperacion }} aplicación</h2>
        <p>Información de la aplicación</p>
      </div>
    </div>

    <button type="button" mat-icon-button class="fise-form-modal__close" (click)="onClicCerrarModal()" aria-label="Cerrar modal">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form class="fise-form-modal__body" [formGroup]="formGroupAplicacion">
    <mat-form-field appearance="outline">
      <mat-label>Dirección IP</mat-label>
      <input aria-label="Dirección IP" matInput readonly type="text" id="direccionIp" name="direccionIp" [(ngModel)]="objectAplicacion.ipServidor" formControlName="controlIp" maxlength="45">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Nombre de la aplicación</mat-label>
      <input aria-label="Nombre de la aplicación" matInput type="text" id="nombreAplicacion" name="nombreAplicacion" required [(ngModel)]="objectAplicacion.idTipo" oninput="this.value = this.value.trimLeft()" formControlName="controlNaplicacion" maxlength="45" soloLetraEspacioNumeroAcento>
      <mat-error *ngIf="formAplicacion.controlNaplicacion.dirty && formAplicacion.controlNaplicacion.errors">El nombre es obligatorio.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Versión</mat-label>
      <input aria-label="Versión" matInput type="text" id="version" name="version" required [(ngModel)]="objectAplicacion.version" oninput="this.value = this.value.trimLeft()" formControlName="controlVersion" maxlength="45" soloLetraEspacioNumeroAcento>
      <mat-error *ngIf="formAplicacion.controlVersion.dirty && formAplicacion.controlVersion.errors">Agregue la versión.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Descripción</mat-label>
      <textarea aria-label="Descripción" matInput id="descripcion" name="descripcion" maxlength="100" rows="3" [(ngModel)]="objectAplicacion.descripcion" oninput="this.value = this.value.trimLeft()" formControlName="controlDescripcion"></textarea>
      <mat-error *ngIf="formAplicacion.controlDescripcion.dirty && formAplicacion.controlDescripcion.errors">Agregue una breve descripción.</mat-error>
    </mat-form-field>
  </form>

  <footer class="fise-form-modal__footer" mat-dialog-actions>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--secondary fise-form-modal__cancel" (click)="onClicCerrarModal()">Cancelar</button>
    <button type="button" mat-raised-button class="app-form-btn app-form-btn--primary fise-form-modal__save" (click)="onClicGuardar()" [disabled]="formGroupAplicacion.invalid">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </footer>
</section>
